import { render, staticRenderFns } from "./FloorMapConfigurator.vue?vue&type=template&id=5e8b2d4b"
import script from "./FloorMapConfigurator.vue?vue&type=script&lang=js"
export * from "./FloorMapConfigurator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports